<template>
    <rkm-area
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.habilitaIntegracaoConectasusCidadao">
                    Habilitar ConectaSUS Cidadão
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Quando ativado, permite disponibilizar e sincronizar vagas configuradas na Jornada para o App do Cidadão. Quando desativado, o sistema oculta os campos do App e não envia vagas, mesmo que estejam configuradas.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox
                    :disabled="!data.model.habilitaIntegracaoConectasusCidadao"
                    v-model="data.model.habilitaAgendamentoConectasusCidadao"
                >
                    Habilitar agendamento de consultas ConectaSUS Cidadão
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Quando ativado, permite realizar agendamentos de consultas através do App do Cidadão.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox
                    :disabled="!data.model.habilitaIntegracaoConectasusCidadao"
                    v-model="data.model.habilitaAgendamentoOutraUnidadeConectasusCidadao"
                >
                    Habilitar agendamento em outra unidade
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Permite ao cidadão agendar consulta pelo aplicativo em unidades diferentes da sua unidade de referência. São ofertadas apenas as unidades marcadas como Unidade de Referência no Cadastro.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.habilitaIntegracaoAplicativoFeridas">
                    Habilitar Aplicativo de Feridas
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Quando ativado, permite disponibilizar a integração com a SafeCare no momento da criação da Jornada.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.habilitaIntegracaoPrescricoesMedicas">
                    <span>
                        Permitir envio das prescrições médicas para o aplicativo ConectaSUS - Cidadão.
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor"
                            small
                            v-rkm-popover.hover.left="{
                                html: true,
                                content: 'Quando ativado, as receitas médicas geradas no atendimento do Ambulatório ficam disponíveis para consulta no APP Cidadão. Quando desativado, a opção de receitas não é exibida ao cidadão no aplicativo.'
                            }"
                        />
                    </span>
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'data.model.habilitaIntegracaoConectasusCidadao'(habilitaIntegracao) {
            if (habilitaIntegracao) return

            this.data.model.habilitaAgendamentoConectasusCidadao = false
            this.data.model.habilitaAgendamentoOutraUnidadeConectasusCidadao = false
        },
    },
}
</script>


<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
